var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ToolTransferPrice extends Component {
    constructor() {
        super('ToolTransferPrice', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.tool-transfer-price').length === 0)
                return;
            $('.tool-transfer-price select, .tool-transfer-price input').on(['change', 'keyup'], (event, input) => {
                const max = parseInt(input.attr('max'));
                if (!isNaN(max) && parseInt(input.val()) > max)
                    input.val(max);
                this.caculatePrices();
            });
            this.caculatePrices();
            this.success();
        });
    }
    caculatePrices() {
        this.distance = parseInt($('#tool-transfer-price-distance').val());
        this.peoples = parseInt($('#tool-transfer-price-peoples').val());
        this.days = parseInt($('#tool-transfer-price-days').val());
        this.parameters = JSON.parse(atob($('.tool-transfer-price').data('parameters')));
        this.caculateSinglePrice('median');
        this.caculateSinglePrice('low');
        this.caculateSinglePrice('high');
    }
    caculateSinglePrice(key) {
        const salary = this.getParameters('salary_' + key);
        const daily_salary = salary / this.getParameters('business_days');
        const days = this.distance === 200 ? 2 : 1;
        const total_salary_1 = daily_salary * this.peoples * (this.days + days);
        const taxes_vacation = total_salary_1 * this.getParameters('taxes_vacation_rate') / 100;
        const total_salary_2 = total_salary_1 + taxes_vacation;
        const production = total_salary_2 * this.getParameters('production_rate') / 100;
        const grand_total = Math.ceil(total_salary_2 + production);
        let price = '';
        if (!isNaN(grand_total)) {
            // format number for Swiss francs
            const formatter = new Intl.NumberFormat('de-CH', {
                style: 'currency',
                currency: 'CHF',
                maximumFractionDigits: 0
            });
            price = formatter.format(grand_total);
        }
        $('#tool-transfer-price-result-' + key).text(price);
    }
    getParameters(key) {
        return parseFloat(this.parameters.find((parameter) => parameter.key === key).value);
    }
}
